import { Editor, Element, Node, Path, Transforms } from 'slate';
import { getBlockTagBindings } from '../types/block';
import { isTag } from './navigation';
import { isFootnote } from './footnote';

export const stripDuplicateTagPlacement = (editor: Editor): boolean => {
  const seen = new Set<string>();
  const seenFootnotes = new Set<string>();
  for (const [node, path] of Node.descendants(editor)) {
    if (!Element.isElement(node)) continue;
    if (isFootnote(node) && node.footnoteId) {
      if (!seenFootnotes.has(node.footnoteId)) {
        seenFootnotes.add(node.footnoteId);
        continue;
      }
      const previous = Path.hasPrevious(path) ? Node.get(editor, Path.previous(path)) : null;
      if (previous && isFootnote(previous) && previous.footnoteId === node.footnoteId) continue;
      Transforms.unwrapNodes(editor, { at: path });
      return true;
    }
    if (isTag(node)) {
      if (!seen.has(node.tagId)) {
        seen.add(node.tagId);
        continue;
      }
      const previous = Path.hasPrevious(path) ? Node.get(editor, Path.previous(path)) : null;
      if (previous && isTag(previous) && previous.tagId === node.tagId) continue;
      Transforms.unwrapNodes(editor, { at: path });
      return true;
    }
    const bindings = getBlockTagBindings(node);
    if (bindings.length === 0) continue;
    const remaining = bindings.filter((b) => !seen.has(b.tagId));
    if (remaining.length !== bindings.length) {
      if (remaining.length) Transforms.setNodes(editor, { tags: remaining } as Partial<Node>, { at: path });
      else Transforms.unsetNodes(editor, 'tags', { at: path });
      return true;
    }
    bindings.forEach((b) => seen.add(b.tagId));
  }
  return false;
};
